/**
 * Add a loading spinner effect to a button
 * @param {HTMLElement} button
 */
export const loadingSpinner = (button) => {
  if (!button) return;
  const spinner = button.querySelector(".loading-overlay__spinner");
  if (spinner) spinner.classList.remove("hidden");
  button.classList.add("loading");
  setTimeout(() => {
    if (spinner) spinner.classList.add("hidden");
    button.classList.remove("loading");
  }, 2000);
};

/* Focus Trap */
export function focusTrap(container) {
  const FOCUSABLE = `
    a[href],
    button:not([disabled]),
    input:not([disabled]),
    textarea:not([disabled]),
    select:not([disabled]),
    details,
    summary,
    [tabindex]:not([tabindex="-1"])
  `;

  const previouslyFocused = document.activeElement;

  function getFocusable() {
    return Array.from(container.querySelectorAll(FOCUSABLE));
  }

  function trap(e) {
    if (e.key !== "Tab") return;

    const focusables = getFocusable();
    if (focusables.length === 0) return;

    const first = focusables[0];
    const last = focusables[focusables.length - 1];

    if (e.shiftKey) {
      if (document.activeElement === first) {
        e.preventDefault();
        last.focus();
      }
    } else {
      if (document.activeElement === last) {
        e.preventDefault();
        first.focus();
      }
    }
  }

  document.addEventListener("keydown", trap);

  return {
    activate() {
      const focusables = getFocusable();
      focusables[0]?.focus();
    },
    deactivate() {
      document.removeEventListener("keydown", trap);
      previouslyFocused?.focus();
    }
  };
}

/* Escape Manager */
window.escManager = (function () {
  let handlers = new Set();

  function onKeydown(e) {
    if (e.key === "Escape") {
      // Call the most recently added handler
      const last = Array.from(handlers).pop();
      last?.();
    }
  }

  document.addEventListener("keydown", onKeydown);

  return {
    add(handler) {
      handlers.add(handler);
    },
    remove(handler) {
      handlers.delete(handler);
    }
  };
})();
